import { render, staticRenderFns } from "./DetailsOld.vue?vue&type=template&id=4507fa22&scoped=true"
import script from "./DetailsOld.vue?vue&type=script&lang=js"
export * from "./DetailsOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507fa22",
  null
  
)

export default component.exports